module.exports = __webpack_public_path__ + "img/img9.21b0c3ba.jpg";